export const addPageProjects = (list) => {
  const projectsList = document.querySelector('[data-projects-list]');

  if (projectsList)
    projectsList.appendChild(list)
}